import {
  FETCH_JTBD_FOLDERS_VIDEOS,
  UPDATE_JTBD_ARCHIVED,
  UPDATE_JTBD_CONTENT,
  UPDATE_JTBD_DELETED,
  UPDATE_JTBD_FOLDERS_VIDEOS,
  UPDATE_JTBD_WATCHED,
} from 'constants/actions';

const DEFAULT_JTBD_STATE = {
  archived: false,
  deleted: false,
  folders: [],
  has_fetched: false,
  is_fetching: false,
  videos: [],
  watched: [],
};

const jTBDReducer = (state = DEFAULT_JTBD_STATE, action) => {
  switch (action.type) {
    case FETCH_JTBD_FOLDERS_VIDEOS:
      return {
        ...state,
        is_fetching: true,
      };
    case UPDATE_JTBD_ARCHIVED:
      return {
        ...state,
        archived: action.archived,
      };
    case UPDATE_JTBD_CONTENT:
      return {
        ...state,
        archived: action.archived,
        deleted: action.deleted,
        watched: action.watched,
      };
    case UPDATE_JTBD_DELETED:
      return {
        ...state,
        deleted: action.deleted,
      };
    case UPDATE_JTBD_FOLDERS_VIDEOS:
      return {
        ...state,
        folders: action.folders || DEFAULT_JTBD_STATE.folders,
        has_fetched: true,
        is_fetching: false,
        videos: action.videos || DEFAULT_JTBD_STATE.videos,
      };
    case UPDATE_JTBD_WATCHED:
      return {
        ...state,
        watched: action.watched,
      };
    default:
      return state;
  }
};

export default jTBDReducer;
